import React from 'react';

import { useTranslation } from '@modernloop/i18n';
import { useFlag } from '@modernloop/shared/feature-flag';
import { DarkModeIcon, LightModeIcon } from '@modernloop/shared/icons';
import { ListItemIcon, MenuItem, Typography } from '@mui/material';

import { useColorScheme } from 'src/contexts/ColorSchemeProvider';

/** Color-scheme preference shown inside the Employee account menu. */
const AccountMenuDarkModeItem = (): JSX.Element | null => {
  const { t } = useTranslation();
  const darkModeEnabled = useFlag('DARK_MODE');
  const { isDarkMode, toggleColorScheme } = useColorScheme();

  if (!darkModeEnabled) {
    return null;
  }

  const label = isDarkMode
    ? t('hiring-dashboard-nav:nav.darkMode.lightLabel')
    : t('hiring-dashboard-nav:nav.darkMode.darkLabel');
  const ariaLabel = isDarkMode
    ? t('hiring-dashboard-nav:nav.darkMode.disable')
    : t('hiring-dashboard-nav:nav.darkMode.enable');

  return (
    <MenuItem
      id="account-menu-dark-mode"
      data-testid="account-menu-dark-mode"
      aria-label={ariaLabel}
      onClick={toggleColorScheme}
    >
      <ListItemIcon>{isDarkMode ? <LightModeIcon /> : <DarkModeIcon />}</ListItemIcon>
      <Typography>{label}</Typography>
    </MenuItem>
  );
};

export default AccountMenuDarkModeItem;
